/* eslint-disable  @typescript-eslint/no-unused-vars */
import { State } from 'xstate';

import { paymentGateway } from './paymentGateway';

type PaymentGatewayMachine = typeof paymentGateway;

type PaymentGatewayState = State<PaymentGatewayMachine['context']>;

export const getGatewayConfig = (machineState: PaymentGatewayState) => {
  const { publicKey, securityToken, serverHost } = machineState.context;
  return {
    serverHost,
    securityToken,
    publicKey,
  };
};

export const getThreeDSecure = (machineState: PaymentGatewayState) => {
  const {
    threeDSecure: { enabled },
  } = machineState.context;
  return enabled;
};

export const getRequiredFieldsConfig = (machineState: PaymentGatewayState) =>
  machineState.context.requiredFields;

export const getVaultCurrencies = (machineState: PaymentGatewayState) =>
  machineState.context.vaultCurrencies;

export const getDefaultVaults = (machineState: PaymentGatewayState) =>
  machineState.context.defaultVaults;

export const paymentGatewaySelectors = {
  getGatewayConfig,
  getThreeDSecure,
  getVaultCurrencies,
  getRequiredFieldsConfig,
  getDefaultVaults,
};
